@let step4 = form();

<ng-container [formGroup]="step4">
  <div class="form-row">
    <mat-form-field>
      <mat-label>Produkt</mat-label>
      <mat-select formControlName="product" okCustomDropDownArrowDirective>
        @for (product of products | enumToArray | translateLocationProduct; track product.value) {
          <mat-option [value]="product.value"> {{ product.label }} </mat-option>
        }
      </mat-select>
      @if (step4.controls.product.value) {
        <button
          matSuffix
          class="clear-input-field-button"
          type="button"
          (click)="step4.controls.product.setValue(null); $event.stopPropagation()"
          aria-label="Ryd indhold i feltet">
          <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
        </button>
      }
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>
  <div class="form-row">
    <mat-slide-toggle formControlName="payoutKickback">
      <b>Udbetal kickback på fastpris prispolitikker</b>
      <br />
      <mat-hint class="tiny-text">En kickback-politik har 3 satser som tildeles alt efter max lade-hastighed på stikket</mat-hint>
    </mat-slide-toggle>
  </div>
  @let kickbacks = kickbacks$ | async;
  @if (step4.controls.payoutKickback.value === true) {
    <div class="form-row">
      <mat-form-field>
        <mat-label>Kickback-politik</mat-label>
        <mat-select formControlName="kickbackId" okCustomDropDownArrowDirective>
          @for (kickback of kickbacks; track kickback.id) {
            <mat-option [value]="kickback.id">
              <span class="ellipsis"
                ><b>{{ kickback.name }}</b></span
              >
              <span class="ellipsis tiny-text">
                Normal {{ kickback.normalRateInKronerExVat | dkCurrency }}&nbsp;&nbsp; Hurtig
                {{ kickback.fastRateInKronerExVat | dkCurrency }}&nbsp;&nbsp; Lyn
                {{ kickback.superRateInKronerExVat | dkCurrency }}
              </span>
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
      </mat-form-field>
    </div>
  }

  <adm-g4-agreement-number
    [control]="step4.controls.agreementNumber"
    [required]="payoutKickbackEnabled()"
    label="kWh godtgørelsesaftalenr" />
  @if (service.powerPriceExclusionFeatureEnabled() && !hasOkPowerMeter()) {
    <div class="form-row">
      <mat-slide-toggle formControlName="hasPowerPriceExclusion">
        <div class="power-price-exclusion-label">
          Ekskludér strømsats i beregning (firmabiler)
          <span
            class="info-icon"
            matTooltip="Strømsats medregnes ikke i betalingen for brugere i organisationen med typen firmabil"
            matTooltipPosition="below">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#info-s"></use></svg>
          </span>
        </div>
      </mat-slide-toggle>
    </div>
  }
</ng-container>
